import React from 'react';
import Notifications from '../Notifications';

const Header = ({
    onNotificationClick,
    isBackendOnline,
    lastUpdateTime,
    isMobile,
    user,
    onLogout,
    isSidebarOpen
}) => {
    const formatDateTime = (value) => {
        if (!value) return '';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const time = date.toLocaleTimeString('en-US', { hour12: true });
        return `${day}-${month}-${year} ${time}`;
    };

    return (
        <>
            <div className="bg-primary h-16 lg:h-20 w-full fixed top-0 left-0 z-[1050] flex items-center px-3 sm:px-4 lg:px-5">
                <div className="lg:hidden w-full flex items-center justify-between gap-3">
                    <div className="min-w-0 flex items-center">
                        <img
                            src="/Atlas_big_bar.png"
                            alt="Atlas Logo"
                            className="h-9 w-auto max-w-[190px] object-contain"
                        />
                    </div>
                    <Notifications
                        onNotificationClick={onNotificationClick}
                        onLogout={onLogout}
                        variant="dark"
                    />
                </div>

                <div className="hidden lg:flex w-full items-center justify-between">
                    <div className="flex flex-col items-start">
                        <img src="/Atlas_big_bar.png" alt="Atlas Logo" className="h-[70px] w-auto" />
                    </div>

                    <div className="flex items-center gap-3 flex-shrink-0">
                        <Notifications
                            onNotificationClick={onNotificationClick}
                            variant="dark"
                        />
                        {user?.displayName && (
                            <div className="relative inline-block">
                                <div className="bg-white/10 text-white text-base font-medium py-1.5 px-3 rounded-md border border-white/20 backdrop-blur-sm cursor-pointer">
                                    <span title={lastUpdateTime ? `Login time: ${formatDateTime(lastUpdateTime)}` : undefined}>{user.displayName}</span>
                                </div>
                            </div>
                        )}
                        <button className="bg-primary text-white py-1.5 px-3 rounded-md cursor-pointer text-base font-medium border-none transition-all duration-200 h-auto leading-snug hover:bg-red-600"
                            onClick={onLogout}>
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Header;
